<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import SettingsForm from "./SettingsForm.vue";
import { useGetSettings, useUpdateSettings } from "./settingsCrud";

const { settings, getSettingsStatus } = useGetSettings();
const { updateSettings, updateSettingsStatus } = useUpdateSettings();
</script>

<template>
  <ManagementLayout>
    <template #header>
      <h1>Einstellungen bearbeiten</h1>
    </template>

    <HandleQueryStatus :query-status="getSettingsStatus">
      <SettingsForm
        v-if="settings !== undefined"
        :update-settings-status="updateSettingsStatus"
        :settings="settings"
        @update="updateSettings"
      />
    </HandleQueryStatus>
  </ManagementLayout>
</template>
